import { isMobileDevice } from 'app/shared/util/method-util';
import update from 'immutability-helper';
import {
  ADD_CUSTOMER_ENTRY,
  ADD_GLOBAL_DATA,
  ADD_PREVIOUS_STEP,
  ActionsTypes,
  CLEAR_STEP_TO_SCROLL,
  REMOVE_CUSTOMER_ENTRY,
  REMOVE_DECLARATION_GLOBAL_DATA,
  REMOVE_DISABLED_NEXT_BUTTON,
  REMOVE_GLOBAL_DATA,
  REMOVE_PREVIOUS_STEP,
  RESET_STEP_ENGINE,
  SET_BACK_TO_HOME,
  SET_COVER,
  SET_PREVIOUS_COVER,
  REMOVE_PREVIOUS_COVER,
  SET_COVER_DISPLAY_NAME,
  SET_CURRENT_STEP,
  SET_CURRENT_STEP_GROUP,
  SET_CUSTOMER_ENTRY,
  SET_DISABLED_NEXT_BUTTON,
  SET_DONT_SHOW_POPUP_REDIRECT_URL,
  SET_GLOBAL_DATA_CREATED_CLAIM,
  SET_GO_TO_LOGIN_ERROR,
  SET_LAST_EDIT_STEP,
  SET_RECEIVED_STEP,
  SET_SHOW_ELIGIBILITY_MODAL,
  SET_SHOW_ERROR_MODAL,
  SET_SHOW_RATING_MODAL,
  SET_SHOW_STEP_ACTION,
  SET_STEP_ENGINE_CREATED_BENEFIT,
  SET_STEP_ENGINE_CREATED_CLAIM,
  SET_STEP_ENGINE_DEVICE_TYPE,
  SET_STEP_ENGINE_SUBSCRIBER,
  SET_STEP_ENGINE_SUBSCRIPTION,
  SET_STEP_GROUP,
  SET_STEP_LIST_COMPONENT,
  SET_STEP_TO_SCROLL,
  SET_USE_CASES,
} from './step-engine-actions';
import { StepEngineState, initialState } from './step-engine-state';

// Reducers

export default (state: StepEngineState = initialState, action: ActionsTypes): StepEngineState => {
  switch (action.type) {
    case SET_RECEIVED_STEP: {
      return {
        ...state,
        stepData: {
          ...state.stepData,
          receivedStep: action.payload,
        },
      };
    }
    case SET_CURRENT_STEP: {
      return {
        ...state,
        stepData: { ...state.stepData, currentSteps: action.payload },
      };
    }
    case SET_STEP_LIST_COMPONENT: {
      return {
        ...state,
        stepData: { ...state.stepData, stepListComponent: action.payload },
      };
    }
    case SET_CURRENT_STEP_GROUP: {
      return {
        ...state,
        stepData: { ...state.stepData, currentStepGroup: action.payload },
      };
    }
    case SET_LAST_EDIT_STEP: {
      return {
        ...state,
        stepData: { ...state.stepData, lastEditStep: action.payload },
      };
    }
    case ADD_PREVIOUS_STEP: {
      const { previousSteps } = state;
      const { targetStep, sourceSteps } = action.payload;

      const targetKey = targetStep.join(',');
      const sourceKey = sourceSteps.join(',');

      // Check if the target step exists in previousSteps
      const previousStepsKeys = Object.keys(previousSteps);
      const targetIndex = previousStepsKeys.indexOf(targetKey);

      // Initialize a new object for updated previous steps
      const updatedPreviousSteps = {};

      if (targetIndex > -1) {
        // Add steps up to the target index
        for (let i = 0; i <= targetIndex; i++) {
          const key = previousStepsKeys[i];
          if (key !== sourceKey) {
            updatedPreviousSteps[key] = previousSteps[key];
          }
        }

        // Add the new sourceSteps -> targetStep mapping
        updatedPreviousSteps[sourceKey] = targetStep;

        // Add remaining steps after the target index
        for (let i = targetIndex + 1; i < previousStepsKeys.length; i++) {
          const key = previousStepsKeys[i];
          if (key !== sourceKey) {
            updatedPreviousSteps[key] = previousSteps[key];
          }
        }
      } else {
        // If target step doesn't exist, add the new mapping directly
        Object.assign(updatedPreviousSteps, previousSteps, {
          [sourceKey]: targetStep,
        });
      }

      return {
        ...state,
        previousSteps: updatedPreviousSteps,
      };
    }

    case REMOVE_PREVIOUS_STEP: {
      return update(state, {
        previousSteps: { $unset: [action.payload.targetStep] }
      });
    }
    case SET_STEP_ENGINE_SUBSCRIPTION:
      return {
        ...state,
        stepData: { ...state.stepData, subscriptionDto: action.payload },
      };
    case SET_STEP_ENGINE_SUBSCRIBER:
      return {
        ...state,
        stepData: { ...state.stepData, subscriptionDto: { ...state.stepData.subscriptionDto, subscriber: action.payload } },
      };
    case SET_STEP_ENGINE_CREATED_CLAIM:
      return {
        ...state,
        stepData: { ...state.stepData, createdClaimNumber: action.payload },
      };
    case SET_GLOBAL_DATA_CREATED_CLAIM:
      return {
        ...state,
        globalData: { ...state.globalData, createdClaimNumber: action.payload },
      };
    case SET_STEP_ENGINE_CREATED_BENEFIT:
      return {
        ...state,
        stepData: { ...state.stepData, createdBenefitId: action.payload },
      };
    case SET_COVER:
      return {
        ...state,
        stepData: {
          ...state.stepData,
          journeyData: { ...state.stepData.journeyData, cover: action.payload },
        },
      };
    case SET_PREVIOUS_COVER:
      return {
        ...state,
        stepData: {
          ...state.stepData,
          journeyData: { ...state.stepData.journeyData, previousCover: action.payload },
        },
      };
    case REMOVE_PREVIOUS_COVER:
      return update(state, {
        stepData: {
          journeyData: { $unset: ['previousCover'] },
        },
      });
    case SET_COVER_DISPLAY_NAME:
      return {
        ...state,
        stepData: {
          ...state.stepData,
          journeyData: {
            ...state.stepData.journeyData,
            coverDisplayName: action.payload,
          },
        },
      };
    case SET_USE_CASES:
      return {
        ...state,
        stepData: {
          ...state.stepData,
          journeyData: {
            ...state.stepData.journeyData,
            useCases: action.payload
          },
        },
        globalData: {
          ...state.globalData,
          useCases: action.payload,
        },
        declarationGlobalData: {
          ...state.declarationGlobalData,
          useCases: action.payload,
        },
      };
    case SET_CUSTOMER_ENTRY: {
      return {
        ...state,
        stepData: {
          ...state.stepData,
          journeyData: {
            ...state.stepData.journeyData,
            customerEntry: action.payload,
          },
        },
      };
    }

    case ADD_CUSTOMER_ENTRY: {
      return {
        ...state,
        stepData: {
          ...state.stepData,
          journeyData: {
            ...state.stepData.journeyData,
            customerEntry: {
              ...state.stepData.journeyData.customerEntry,
              [action.payload.customerEntryName]: action.payload.value,
            },
          },
        },
      };
    }

    case REMOVE_CUSTOMER_ENTRY: {
      return update(state, {
        stepData: {
          journeyData: {
            customerEntry: { $unset: [action.payload.customerEntryName] },
          },
        },
      });
    }

    case ADD_GLOBAL_DATA: {
      return {
        ...state,
        globalData: {
          ...state.globalData,
          [action.payload.key]: action.payload.value,
        },
        declarationGlobalData: {
          ...state.declarationGlobalData,
          [action.payload.key]: action.payload.value,
        },
      };
    }
    case REMOVE_GLOBAL_DATA: {
      return update(state, { globalData: { $unset: [action.payload.key] } });
    }
    case REMOVE_DECLARATION_GLOBAL_DATA: {
      return update(state, { declarationGlobalData: { $unset: [action.payload.key] } });
    }
    case RESET_STEP_ENGINE: {
      return {
        ...state,
        previousSteps: {},
        stepData: {
          currentStepGroup: '',
          stepListComponent: {},
          currentSteps: ['GET_FIRST_STEP'],
          lastEditStep: '',
          additionalStep: '',
          journeyData: {
            customerEntry: {},
            cover: null,
            previousCover: "",
            coverDisplayName: '',
            useCases: null,
          },
          showStepAction: null,
          stepGroup: '',
          subscriptionDto: { ...state.stepData.subscriptionDto },
          createdClaimNumber: '',
          createdBenefitId: '',
          receivedStep: null,
          deviceType: state.stepData.deviceType,
        },
        backToHome: false,
        disabledNextButton: {},
        showEligibilityModal: false,
        showErrorModal: false,
        globalData: {
          subscriptionNumber: state.globalData.subscriptionNumber,
          subscriptionDate: state.declarationGlobalData.subscriptionDate,
          clientNumber: state.globalData.clientNumber,
          mobile: isMobileDevice(),
        },
        declarationGlobalData: {
          subscriptionNumber: state.declarationGlobalData.subscriptionNumber,
          subscriptionDate: state.declarationGlobalData.subscriptionDate,
          clientNumber: state.declarationGlobalData.clientNumber,
          mobile: isMobileDevice(),
        },
      };
    }
    case SET_BACK_TO_HOME: {
      return {
        ...state,
        backToHome: action.payload,
      };
    }
    case SET_GO_TO_LOGIN_ERROR: {
      return {
        ...state,
        goToLoginError: action.payload,
      };
    }
    case SET_SHOW_ELIGIBILITY_MODAL: {
      return {
        ...state,
        showEligibilityModal: action.payload,
      };
    }
    case SET_STEP_TO_SCROLL: {
      return {
        ...state,
        stepToScroll: action.payload,
      };
    }
    case CLEAR_STEP_TO_SCROLL: {
      return {
        ...state,
        stepToScroll: ""
      };
    }
    case SET_DISABLED_NEXT_BUTTON: {
      return {
        ...state,
        disabledNextButton: { ...state.disabledNextButton, [action.payload.key]: action.payload.value },
      };
    }
    case REMOVE_DISABLED_NEXT_BUTTON: {
      return update(state, { disabledNextButton: { $unset: [action.payload.key] } });
    }
    case SET_SHOW_ERROR_MODAL: {
      return {
        ...state,
        showErrorModal: action.payload,
      };
    }
    case SET_SHOW_RATING_MODAL: {
      return {
        ...state,
        showRatingModal: action.payload,
      };
    }
    case SET_SHOW_STEP_ACTION: {
      return {
        ...state,
        stepData: {
          ...state.stepData,
          showStepAction: action.payload,
        },
      };
    }
    case SET_STEP_GROUP: {
      return {
        ...state,
        stepData: {
          ...state.stepData,
          stepGroup: action.payload,
        },
      };
    }
    case SET_STEP_ENGINE_DEVICE_TYPE:
      return {
        ...state,
        stepData: { ...state.stepData, deviceType: action.payload },
      };

    case SET_DONT_SHOW_POPUP_REDIRECT_URL: {
      return {
        ...state,
        stepData: {
          ...state.stepData,
          dontShowPopupRedirectUrl: action.payload,
        },
      };
    }
    default:
      return state;
  }
};
